import type { BoxProps } from '@mui/system';
import type { ReactNode } from 'react';

import type { SlabTabOption } from './SlabTabContext';
import { SlabTabPanel } from './SlabTabPanel';

interface SlabTabViewProps<T extends string> extends Omit<BoxProps, 'children'> {
  tabs: SlabTabOption<T>[];
}

export const SlabTabView = <T extends string>({
  tabs,
  ...props
}: SlabTabViewProps<T>): ReactNode => {
  if (!tabs.length) return null;

  return (
    <>
      {tabs.map(({ element, label }) => (
        <SlabTabPanel key={label} element={element} value={label} {...props} />
      ))}
    </>
  );
};
